"use strict";
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds.
 *
 * @param {*} func - wrapped function
 * @param {*} timeout - timeout in ms (`100`)
 * @returns function
 */
Object.defineProperty(exports, "__esModule", { value: true });
const debounce = (func, timeout) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, timeout);
    };
};
exports.default = debounce;
